<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      :type="multiple ? 'multi-check' : 'default'"
      :width="width"
      :options="active ? activeProductBrandOptions : productBrandOptions"
      placeholder="品牌"
      :filterable="false"
  ></gj-select>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "gj-brand-select",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: '160px'
      }
    },
    computed: {
      ...mapGetters(['productBrandOptions', 'activeProductBrandOptions']),
    },
  }
</script>

<style scoped>
  /deep/ .el-select__tags-text {
    max-width: 40px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: margin .3s cubic-bezier(.645,.045,.355,1);
  }
  /deep/ .el-tag__close.el-icon-close {
    top: -6px;
  }
</style>
